// Canned synthetic matching bench pairs (PLAN P2-7). Every value is INVENTED — no real applicant
// record may be copied into an example. Unlike the watchlist/colour benches, matching has no
// vendored "full clean profile" (the field catalogue is 391 paths across two entities — SPEC
// §6.5) — this is a small illustrative `{gc, ip}` pair over a handful of real catalogue paths, not
// an exhaustive one. A field this pair does not set reads as `source_absent`/N/A for any rule that
// needs it, which is the correct "missing data never quietly punishes" behaviour (SPEC §3.3), not a
// defect of the sample.
export interface DryRunMatchingSamplePair {
  readonly id: string;
  readonly labelKey: string;
  readonly profile: { gc: Record<string, unknown>; ip: Record<string, unknown> };
}

export const DRY_RUN_MATCHING_SAMPLE_PAIRS: DryRunMatchingSamplePair[] = [
  {
    id: 'baseline',
    labelKey: 'rules.dryRun.matchingSample.baseline',
    profile: {
      gc: {
        age: 32,
        bmi: 24,
        residency: 'Texas',
        isSurrogateBefore: true,
        numberOfDeliveries: 1,
        numberOfSections: 0,
        hasAbortions: false,
        surroAvailableInDatabase: '2026-01-01',
      },
      ip: {
        state: 'California',
        clinicName: 'Example Fertility Clinic',
        embryoTransferType: 'Single',
        isConsiderTerminationGender: false,
        startSurroSearch: '2025-12-01',
      },
    },
  },
];
